import {
  FetchLayerCredentials,
  CartoSourceCredentials,
} from './fetch-layer.type'

export function getFetchLayerCredentials(
  baseUrl: string,
  token: string,
): FetchLayerCredentials {
  return { apiVersion: 'v3', apiBaseUrl: baseUrl, accessToken: token }
}

// deck.gl v9 source functions / query() take credentials inline (no global
// setDefaultCredentials). This assembles them from the app's base_url, the live
// access token, and the resolved connection name.
export function getCartoSourceCredentials(
  baseUrl: string,
  token: string,
  connectionName: string,
): CartoSourceCredentials {
  return { accessToken: token, apiBaseUrl: baseUrl, connectionName }
}
